import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStateStyles = (FOUNDATIONS, styles) => {
    return {
        parentContainer: {
            width: '100%',
            height: 'auto',
            display: 'flex',
            flex_direction: 'column',
            row_gap: FOUNDATIONS.spacing_150,
            ...styles.parentContainer,
        },
        iconAndMainTitleContainer: {
            display: 'flex',
            align_items: 'center',
            column_gap: FOUNDATIONS.spacing_150,
            ...styles.iconAndMainTitleContainer,
        },
        cardContainer: {
            width: '100%',
            height: 'auto',
            display: 'flex',
            flex_direction: 'column',
            row_gap: FOUNDATIONS.spacing_00,
            padding: `${FOUNDATIONS.spacing_250}`,
            column_gap: FOUNDATIONS.spacing_250,
            border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_comp_forms_switchcard_border}`,
            border_radius: FOUNDATIONS.radius_comp_forms_switchcard_radiussize,
            background: FOUNDATIONS.color_comp_containers_bg,
            cursor: 'pointer',
            ...styles.cardContainer,
        },
        elementsAndToggleContainer: {
            width: '100%',
            display: 'flex',
            column_gap: FOUNDATIONS.spacing_250,
            ...styles.elementsAndToggleContainer,
        },
        elementsContainer: {
            display: 'flex',
            flex: 1,
            flex_direction: 'column',
            row_gap: FOUNDATIONS.spacing_150,
            ...styles.elementsContainer,
        },
        customContentContainer: {
            display: 'flex',
            flex: 1,
            flex_direction: 'column',
            row_gap: FOUNDATIONS.spacing_150,
            ...styles.customContentContainer,
        },
        toggleContainer: {
            ...styles.toggleContainer,
        },
        loaderContainer: {
            ...styles.loaderContainer,
        },
        tooltipContainer: {
            top: '0',
            margin_left: FOUNDATIONS.spacing_150,
            vertical_align: 'bottom',
            display: 'inline-flex',
            ...styles.tooltipContainer,
        },
        tooltipIcon: {
            ...styles.tooltipIcon,
            vertical_align: 'baseline',
            display: 'inline-block',
            ...styles.tooltipIcon,
        },
        mainTitle: {
            font_variant: TextVariantType.FONT_HEADING_450,
            font_weight: FONT_WEIGHT.font_weight_600,
            color: FOUNDATIONS.color_neutral_font_50,
            ...styles.mainTitle,
        },
        icon: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_secondary_icon_100,
            ...styles.icon,
        },
        label: {
            font_variant: TextVariantType.FONT_PARAGRAPH_350,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_neutral_font_100,
            ...styles.label,
        },
        title: {
            font_variant: TextVariantType.FONT_PARAGRAPH_250,
            font_weight: FONT_WEIGHT.font_weight_600,
            color: FOUNDATIONS.color_neutral_font_50,
            line_height: FOUNDATIONS.font_line_height_paragraph_medium,
            ...styles.title,
        },
        description: {
            font_variant: TextVariantType.FONT_PARAGRAPH_350,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_neutral_font_50,
            ...styles.description,
        },
        contentContainer: {
            display: 'grid',
            grid_template_rows: '0',
            transition: `grid-template-rows ${FOUNDATIONS.duration_175} ease-in-out`,
            ...styles.contentContainer,
        },
        innerContent: {
            padding_top: `${FOUNDATIONS.spacing_250}`,
            ...styles.innerContent,
        },
    };
};
//# sourceMappingURL=commonStyles.js.map